import { ProgressSpinner } from "primereact/progressspinner";
import { columnSettings } from "./report-template-setting";

const MobileList = ({ listData, loading }) => {
    const groups = {};
    listData.forEach((row) => {
        const key = row.group_label || row?.nomor_polisi || "-";
        if (!groups[key]) groups[key] = [];
        groups[key].push(row);
    });

    // Mapping for easy access
    const settings = {};
    for (let column of columnSettings) {
        settings[column.field] = column;
    }

    return (
        <div className="flex flex-col gap-4 p-4 w-full">
            {loading && (
                <div className="flex justify-center">
                    <ProgressSpinner />
                </div>
            )}

            {!loading && Object.keys(groups).length === 0 && (
                <p className="text-center text-slate-500">No data available</p>
            )}

            {!loading &&
                Object.keys(groups).map((key) => {
                    const groupRows = groups[key];
                    const groupData = groupRows[0].group_data || groupRows[0].data_kendaraan;

                    return (
                        <div
                            key={groupData?.nomor_polisi}
                            className="bg-zinc-50 rounded-xl shadow-sm border border-zinc-200 overflow-hidden"
                        >
                            {/* Group header */}
                            <div className="bg-indigo-100 px-4 py-2 font-semibold text-indigo-800 border-b border-zinc-200">
                                {groupData?.nomor_polisi} ({groupData?.jenis_mobil})
                            </div>

                            {/* Detail rows */}
                            {groupRows
                                .filter((row) => row.report_type === "detail")
                                .map((row, index) => (
                                    <div
                                        key={row.mykey ?? index}
                                        className="px-4 py-2 border-b border-zinc-200 bg-white"
                                    >
                                        {Object.keys(settings)
                                            .filter((field) => field !== "no") // skip NO if needed
                                            .map((field) => {
                                                const col = settings[field];
                                                let value = row[field];

                                                // Formatting
                                                if (col.type === "number") {
                                                    if (value === null || value === undefined || value === 0) {
                                                        value = "-";
                                                    } else {
                                                        value = value.toLocaleString("id-ID");
                                                    }
                                                } else if (col.type === "date" && value) {
                                                    value = new Date(value).toLocaleDateString("id-ID", {
                                                        day: "2-digit",
                                                        month: "short",
                                                        year: "numeric",
                                                    });
                                                } else if (value === null || value === undefined) {
                                                    value = "-";
                                                } else if (typeof value === "object" && value?.nama) {
                                                    value = value.nama;
                                                }

                                                // Special case for keterangan (stacked vertically)
                                                if (field === "keterangan") {
                                                    return (
                                                        <div key={field} className="flex flex-col mb-1">
                                                            <span className="text-slate-600 font-bold">{col.name}:</span>
                                                            <span className="text-slate-800">{value}</span>
                                                        </div>
                                                    );
                                                }

                                                // Special case for selisih with warning/danger colors
                                                // Special case for selisih with warning/danger colors
                                                let cellClass = "";
                                                if (field === "selisih") {
                                                    const selisih = row.selisih ?? 0;
                                                    const speedo_akhir = row.speedo_akhir ?? 0;
                                                    const last = row.last ?? 0;
                                                    const km_warning = row.km_warning ?? 0;
                                                    const next = row.next ?? 0;

                                                    let newSelisih = selisih;

                                                    const kmWarningAll = km_warning + last;
                                                    let isWarning = speedo_akhir >= kmWarningAll && speedo_akhir < next;
                                                    let isDanger = speedo_akhir >= next;

                                                    if (next <= 0) {
                                                        isWarning = false;
                                                        isDanger = false;
                                                        newSelisih = 0;
                                                    }

                                                    cellClass = isWarning
                                                        ? "bg-yellow-100 text-yellow-600"
                                                        : isDanger
                                                            ? "bg-red-100 text-red-600"
                                                            : "";

                                                    // optionally update value to newSelisih (if you want displayed selisih to respect next <= 0)
                                                    value = newSelisih === 0 ? "-" : newSelisih.toLocaleString("id-ID");
                                                }

                                                return (
                                                    <div
                                                        className={`row-between-start mb-1 ${cellClass}`}
                                                        key={field}
                                                    >
                                                        <span className="text-slate-600 font-bold">{col.name}:</span>
                                                        <span className="text-slate-800">{value}</span>
                                                    </div>
                                                );
                                            })}
                                    </div>
                                ))}

                            {/* Group footer */}
                            <div
                                className={`px-4 py-2 bg-indigo-50 font-semibold text-right ${groupRows.some((row) => {
                                    const next = row.next ?? 0;
                                    const speedo_akhir = row.speedo_akhir ?? 0;
                                    const last = row.last ?? 0;
                                    const km_warning = row.km_warning ?? 0;

                                    if (next <= 0) return false;

                                    const kmWarningAll = km_warning + last;
                                    const isWarning = speedo_akhir >= kmWarningAll && speedo_akhir < next;
                                    const isDanger = speedo_akhir >= next;

                                    return isWarning || isDanger;
                                })
                                    ? "text-red-600"
                                    : "text-indigo-800"
                                    }`}
                            >
                                Total Warning:{" "}
                                {groupRows
                                    .filter((row) => {
                                        const next = row.next ?? 0;
                                        const speedo_akhir = row.speedo_akhir ?? 0;
                                        const last = row.last ?? 0;
                                        const km_warning = row.km_warning ?? 0;

                                        if (next <= 0) return false;

                                        const kmWarningAll = km_warning + last;
                                        const isWarning = speedo_akhir >= kmWarningAll && speedo_akhir < next;
                                        const isDanger = speedo_akhir >= next;

                                        return isWarning || isDanger;
                                    })
                                    .length.toLocaleString("id-ID")}
                            </div>
                        </div>
                    );
                })}
        </div>
    );
};

export default MobileList;
